export const createDropdownConfig = ({
  iconHoverStyle = 0
} = {}) => {
  return {
    iconHoverStyle,
  }
}